













import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import {
  Size,
} from "../../../../domain/drawing";
import { ModelEditableMixin } from "../../../system/mixins";
import { StandardOption } from "../../../system/selectors/mixins";
import OptionRadioSelector from "../../../system/selectors/OptionRadioSelector.vue";

@Component({
  components: {
    selector: OptionRadioSelector,
  },
})
export default class StampableLocatorMenu extends Mixins(ModelEditableMixin) {
  @Prop({ default: () => StampableLocatorMenu.DefaultStampSizes })
  sizes: StandardOption<Size>[];

  data(): any {
    const selectedSize = Enumerable.from(this.sizes)
      .firstOrDefault(s => Size.areEqual(this.value, s.value));
    return {
      shouldStamp: !!selectedSize,
      stampSizes: this.sizes,
      selectedStampSize: !selectedSize ? Enumerable.from(this.sizes).select(s => s.value).lastOrDefault() : selectedSize.value,
    };
  }
  shouldStamp: boolean;
  stampSizes: StandardOption<Size>[];
  selectedStampSize: Size;

  public static DefaultStampSizes = [
    StampableLocatorMenu.toOption("大", new Size(40, 40)),
    StampableLocatorMenu.toOption("中", new Size(30, 30)),
    StampableLocatorMenu.toOption("小", new Size(20, 20)),
  ] as StandardOption<Size>[];

  private static toOption(label: string, size: Size): StandardOption<Size> {
    return new StandardOption<Size>(
      label,
      size,
      size.width + "x" + size.height + "サイズで配置します。"
    );
  }

  get result(): Size {
    return this.shouldStamp
      ? this.selectedStampSize
      : null;
  }

  @Watch("result")
  onResultUpdated(newValue: Size, oldValue: Size): void {
    this.input(newValue);
  }
}
